import styled from 'styled-components';

import { transition } from 'theme';

import { ShareButton } from './ShareButton';

export const SocialButton = styled(ShareButton)`
  margin: 6px;
  transition: all ${transition};
`;
